export enum CompatiblePairKpdReasons {    
    Other = 0,
    HLAMatch = 1,
    YoungerDonor = 2,
    LargerDonor = 3,
    ComplexAnatomy = 4,
    AvoidDSa = 5,
    AvoidPrevMismatch = 6,
    Altruism = 7
}